var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtworkLeaderboard = function SvgIconArtworkLeaderboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m18.85 14.019-2.609-6.1c-.474-1.117-1.183-1.75-1.991-1.792-.8-.041-1.575.517-2.167 1.584L10.5 10.552c-.334.6-.808.959-1.325 1-.525.05-1.05-.225-1.475-.766l-.183-.234c-.592-.741-1.325-1.1-2.075-1.025s-1.392.592-1.817 1.434l-1.442 2.874a3.31 3.31 0 0 0 .142 3.234 3.3 3.3 0 0 0 2.825 1.575h10.633a3.32 3.32 0 0 0 2.775-1.492 3.26 3.26 0 0 0 .292-3.133M6.308 6.985a2.817 2.817 0 1 0 0-5.633 2.817 2.817 0 0 0 0 5.633"
  })));
};
export default SvgIconArtworkLeaderboard;